module.exports = __webpack_public_path__ + "img/about-logo.d78a7f5b.png";